'use client';
import "./app/globals.css";
import {
    DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel,
    DropdownMenuSeparator, DropdownMenuTrigger
} from "@/components/ui/dropdown-menu";
import {Avatar, AvatarFallback, AvatarImage} from "@/components/ui/avatar";
import {Button} from "@/components/ui/button";
import {Building2, Search} from "lucide-react";
import {Input} from "@/components/ui/input";
import {MeApi,} from "@/api/generated";
import {getApiConfig, getAuthStatus} from "@/api/api";
import {useState, createContext, useEffect} from "react";
import {AppSidebar} from "@/components/app-sidebar";
import {
    Sidebar,
    SidebarInset,
    SidebarMenu,
    SidebarMenuItem,
    SidebarProvider,
    SidebarTrigger
} from "@/components/ui/sidebar";
import {Skeleton} from "@/components/ui/skeleton";
import {useAuth} from "@/context/AuthContext";
import {
    NavigationMenu,
    NavigationMenuContent,
    NavigationMenuItem,
    NavigationMenuLink,
    NavigationMenuList,
    NavigationMenuTrigger
} from "@/components/ui/navigation-menu";
import {NavBar} from "@/components/nav-bar";
import {ScrollArea} from "./components/ui/scroll-area";

export default function AuthenticatedLayout({
                                                children,
                                            }: Readonly<{
    children: React.ReactNode;
}>) {
    return (
        <SidebarProvider className="w-full overflow-hidden">
            {/*<Sidebar user={me!}  onOrgSwitch={() => {}} currentOrgId={"1"} organizations={[]}/>*/}
            <AppSidebar></AppSidebar>
            <SidebarInset className="w-full overflow-hidden">
                <div className="flex flex-col w-full h-screen overflow-hidden">
                        <span className="w-full overflow-hidden">
                            <NavBar/>
                        </span>
                    <div className="flex-1 w-full flex overflow-hidden">
                        {children}
                    </div>
                </div>
            </SidebarInset>
        </SidebarProvider>
    );
}